import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import {
  getBalanceCheckerEditorCode,
  setBalanceCheckerEditorCode,
} from "123tcs-common/utils/storage";
import React, { useEffect, useState } from "react";
import Style from "style-it";
import { SIMULATION_CARD } from "../../constants/simulation";
import { SimulationProvider } from "../../contexts/Simulation";
import BalanceChecker from "../balance-checker/BalanceChecker";
import BalanceCheckerResult from "../balance-checker/BalanceCheckerResult";
import BalanceCheckerCSSEditor from "./BalanceCheckerCSSEditor";
import BalanceCheckerEditorHeader from "./BalanceCheckerEditorHeader";
import BalanceCheckerEditorSettings from "./BalanceCheckerEditorSettings";
import BalanceCheckerHTMLViewer from "./BalanceCheckerHTMLViewer";

function BalanceCheckerEditor() {
  // States
  const [code, setCode] = useState(getBalanceCheckerEditorCode() || "");

  // Functions
  const handleCode = (newCode) => {
    setCode(newCode);
    setBalanceCheckerEditorCode(newCode);
  };

  const balanceBracketsString = (cssString) => {
    const stack = [];
    let balancedString = cssString;

    Array.from(cssString).forEach((char) => {
      if (char === "{") {
        stack.push("{");
      } else if (char === "}") {
        if (stack.length === 0) {
          balancedString = `{${balancedString}`;
        } else {
          stack.pop();
        }
      }
    });

    balancedString += "}".repeat(stack.length);

    return balancedString;
  };

  // Effects
  useEffect(() => {
    if (code === "") {
      fetch("/assets/css/default.css")
        .then((response) => response.text())
        .then((text) => setCode(text));
    }
  }, []);

  // Render
  return (
    <>
      {/* Style is only applied to elements within  */}
      <Style>
        {`#editorCSS  {
                ${balanceBracketsString(code)}
            }`}
      </Style>

      {/* HEADER */}
      <BalanceCheckerEditorHeader />

      {/* SETTINGS */}
      <BalanceCheckerEditorSettings />

      {/* CONTENT */}
      <Grid container sx={{ backgroundColor: "action.hover" }}>
        {/* EDITOR */}
        <Grid size={{ lg: 6, md: 12 }} sx={{ p: 2 }}>
          <Stack
            spacing={1}
            // v. height - header - settings - padding
            sx={{ display: "flex", height: `calc(100vh - 66px - 77px - 32px)` }}
          >
            <BalanceCheckerCSSEditor value={code} onChange={handleCode} />
            <BalanceCheckerHTMLViewer />
          </Stack>
        </Grid>

        {/* PREVIEWS */}
        <Grid size={{ lg: 6, md: 12 }} sx={{ p: 2 }}>
          <Stack spacing={1}>
            <Paper id="editorCSS" variant="outlined">
              <Box
                display="flex"
                sx={{
                  padding: 1,
                  alignItems: "center",
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Typography variant="h6">Form Preview</Typography>
              </Box>

              <Box sx={{ padding: 4 }}>
                <SimulationProvider simulateEditorSettings showTooltips>
                  <BalanceChecker />
                </SimulationProvider>
              </Box>
            </Paper>

            <Paper id="editorCSS" variant="outlined">
              <Box
                display="flex"
                sx={{
                  padding: 1,
                  alignItems: "center",
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Typography variant="h6">Result Preview</Typography>
              </Box>

              <Box sx={{ padding: 4 }}>
                <SimulationProvider simulateEditorSettings showTooltips>
                  <BalanceCheckerResult card={SIMULATION_CARD} showEndOfLife />
                </SimulationProvider>
              </Box>
            </Paper>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}

export default BalanceCheckerEditor;
